module.exports = __webpack_public_path__ + "img/file-earmark-binary-fill.61c22eb9.svg";